module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSI5IiB2aWV3Qm94PSIwIDAgMTYgOSI+CiAgICA8cGF0aCBmaWxsPSIjMDBCOTM2IiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik04LjcgMmgzLjZMOC43IDUuNmwtNC00TDAgNi4zbDEuNCAxLjQgMy4zLTMuMyA0IDQgNS01VjdoMlYwaC03eiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/high-icon.svg
// module id = mUaz
// module chunks = 1